<template>
  <ValidationProvider
    ref="provider"
    mode="eager"
    :vid="name"
    :name="validateAs"
    :rules="rules"
    :bails="false"
    v-slot="{ classes, errors }"
    tag="div"
    :class="{ 'opacity-75 cursor-not-allowed': disabled }"
  >
    <div
      v-for="option in options"
      :key="option"
      @click="handleInput(option)"
      :class="{ 'bg-primary-500 text-white': localValue === option }"
      class="flex items-center border border-gray-200 rounded-[8px] py-4 px-6 cursor-pointer hover:border-gray-500 transition-colors mb-4"
    >
      <div class="flex items-center justify-center flex-none w-4 h-4 mr-4 bg-white border border-gray-200 rounded-full">
        <div class="h-[6px] w-[6px] rounded-full transition-colors" :class="{ 'bg-primary-500': localValue === option }"></div>
      </div>
      <div>
        <div class="font-bold mb-[4px]">{{ $t(`${i18n}.${option}_title`) }}</div>
        <div class="text-12 text-gray-300 transition-colors" :class="{ ' !text-white': localValue === option }">{{ $t(`${i18n}.${option}_description`) }}</div>
      </div>
    </div>
    <span v-if="errors[0] && (classes.dirty || formValdiated)" class="text-red text-14 block mt-4 font-semibold">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script lang="ts">
  import { Field as ValidationProvider } from "vee-validate";
  import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-facing-decorator";

  @Component({
    components: {
      ValidationProvider,
    },
  })
  export default class FormTypeSelect extends Vue {
    @Prop() name?: string;

    @Prop() value?: string;

    @Prop() options?: string[];

    @Prop() rules?: string | object;

    @Prop({ default: false }) disabled!: boolean;

    @Prop() label?: string;

    @Prop({ default: "forms" }) i18n?: string;

    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    localValue: string | null = null;

    private get formValdiated(): boolean {
      return this.provider.meta.validated;
    }

    private get validateAs(): string {
      if (this.label) {
        return this.label;
      }

      if (this.name) {
        return this.name;
      }

      return `ye/no field`;
    }

    @Emit("input")
    private handleInput(value: string) {
      this.localValue = value;
      return this.localValue;
    }

    @Watch("value", { immediate: true })
    private valueChanged(newValue: string | null) {
      this.localValue = newValue;
    }
  }
</script>
